export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'MARKER_TYPES_105_SET':
    return payload
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
